export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    AddDomainResponse: ["ErrorResponse", "Org"],
    AgentChatThreadSafeResult: [
      "AgentChatThread",
      "AssetAccess",
      "MissingProjectRole",
      "ThreadNotFound",
    ],
    AuthConfiguration: ["OpenIdAuthConfiguration"],
    CellContents: [
      "BlockCell",
      "CellGroupCell",
      "ChartCell",
      "CodeCell",
      "CollapsibleCell",
      "ComponentImportCell",
      "DbtMetricCell",
      "DisplayTableCell",
      "ExploreCell",
      "FilterCell",
      "MapCell",
      "MarkdownCell",
      "MetricCell",
      "Parameter",
      "PivotCell",
      "SqlCell",
      "TextCell",
      "VegaChartCell",
      "WritebackCell",
    ],
    CollectionGrantHolder: ["Group", "IntrinsicGroup", "User"],
    ContextSuggestionFilePreview: [
      "ContextSuggestionFilePreviewNoOp",
      "ContextSuggestionFilePreviewUnversioned",
      "ContextSuggestionFilePreviewVersioned",
    ],
    ContextSuggestionFilePreviewResult: [
      "ContextSuggestionFilePreviewFailure",
      "ContextSuggestionFilePreviewSuccess",
    ],
    CreateMagicApiKeysResult: [
      "CreateMagicApiKeysSuccess",
      "CreateMagicApiKeysValidationError",
    ],
    CreateOrgResponse: ["ErrorResponse", "Org"],
    DataConnectionSafeResult: ["DataConnection", "UnknownDataConnection"],
    GetSqlFromHqlResponse: ["ErrorResponse", "HqlToSqlResponse"],
    GridElementEntity: ["Cell", "SharedFilter"],
    HexVersionAppUserReason: ["MissingOrgRole", "MissingProjectRole"],
    HexVersionDenialReason: ["AssetAccess", "MissingProjectRole"],
    HexVersionHistoryEventUnion: ["HexAOLog", "HexVersion", "HexVersionAOLog"],
    HexVersionSafeResult: [
      "AssetAccess",
      "HexNotFound",
      "HexVersion",
      "MissingProjectRole",
    ],
    HexVersionViewerReason: [
      "Archived",
      "AssetAccess",
      "MissingOrgRole",
      "MissingProjectRole",
      "NonDraftVersion",
      "OAuthCollaborationNonSessionOwner",
      "OAuthCredsNotShared",
      "Trashed",
    ],
    OutputContentSafeResult: ["OutputContent", "OutputContentNotFound"],
    ParsedPythonCellReferences: [
      "CellReferencesParseError",
      "PythonCellReferences",
    ],
    ProjectGrantHolder: ["ApiClient", "Group", "User"],
    RecentlyUsedDataSource: [
      "DataSourceTable",
      "SemanticDataset",
      "SemanticView",
    ],
    Recipient: ["Group", "SlackChannel", "User"],
    ReviewRequestLinkTarget: [
      "ReviewRequestLinkGroupTarget",
      "ReviewRequestLinkUserTarget",
    ],
    SafeOrUnknownAgentChatThread: ["AgentChatThread", "UnknownAgentChatThread"],
    SafeOrUnknownComponentReference: [
      "ComponentReference",
      "UnknownComponentReference",
    ],
    SafeOrUnknownExplore: ["Explore", "UnknownExplore"],
    SafeOrUnknownHexResult: ["Hex", "UnknownHex"],
    SafeOrUnknownHexVersionResult: ["HexVersion", "UnknownHexVersion"],
    SafeOrUnknownHexesResult: ["Hex", "UnknownHex"],
    SafeOrUnknownTask: ["Task", "UnknownTask"],
    SafeOrUnknownThreadsCellReference: [
      "ThreadsCellReference",
      "UnknownThreadsCellReference",
    ],
    SemanticProjectHex: ["Hex", "UnknownHex"],
    SemanticProjectHistoryNode: ["SemanticProjectVersion"],
    SemanticProjectSearchResourcesResult: [
      "SemanticDatasetSearchResult",
      "SemanticViewSearchResult",
    ],
    SharedAssetGrantHolder: ["Group", "IntrinsicGroup"],
    SharedAssetGrantTarget: [
      "DataConnection",
      "ExternalFileIntegration",
      "File",
      "Secret",
      "SyncRepository",
      "VcsPackage",
    ],
  },
};
export default result;
